import { SideMenu } from "../models/SideMenu";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import EmergencyRecordingIcon from '@mui/icons-material/EmergencyRecording';
import InfoRounded from "@mui/icons-material/InfoRounded";
import PolicyRoundedIcon from "@mui/icons-material/PolicyRounded";
import AccountBoxRounded from "@mui/icons-material/AccountBoxRounded";
import {
  EngineeringRounded,
  FoundationRounded,
  TableViewRounded,
  ReportProblemRounded,
  Paid,
  Mail,
} from "@mui/icons-material";

import HomeRounded from "@mui/icons-material/HomeRounded";

export const RootMenu: SideMenu[] = [
  {
    label: "Dashboard",
    icon: HomeRounded,
    link: "/admin-dashboard",
  },
  {
    label: "DSF Admin",
    icon: AccountBoxRounded,
    link: "/dsf-admin",
  },
  {
    label: "Clients",
    icon: PersonRoundedIcon,
    link: "/client-table",
  },
  {
    label: "Consultants",
    icon: EngineeringRounded,
    link: "/consultant-table",
  },
  {
    label: "Setup",
    icon: PolicyRoundedIcon,
    link: "/consultant-table",
    childMenu: [
      {
        label: "Industries",
        link: "/industries",
      },
      {
        label: "App Access Levels",
        link: "/access-level-table",
      },
      {
        label: "Documents",
        link: "/documents-table",
      },
      {
        label: "Appointments",
        link: "/appointment-table",
      },
      {
        label: "Organogram",
        link: "/appointment-tree",
      },
      {
        label: "Equipment Types",
        link: "/equipment-types-table",
      },
      {
        label: "Vehicle Types",
        link: "/vehicle-types-table",
      },
      {
        label: "Chemical Types",
        link: "/chemical-types-table",
      },
      {
        label: "Equipment List",
        link: "/equipment-list-table",
      },
      {
        label: "Incident Types",
        link: "/incident-type-view",
      },
      {
        label: "PPE",
        link: "/ppe-table",
      },
      {
        label: "Control Measures Types",
        link: "/control-measure-type-table",
      },
    ],
  },
  {
    label: "Risks",
    icon: ReportProblemRounded,
    link: "/consultant-table",
    childMenu: [
      {
        label: "1) Safe Work Method",
        link: "/safe-work-method-table",
      },
      {
        label: "2) Job Task",
        link: "/risk-task-table",
      },
      {
        label: "3) Job Step",
        link: "/risk-step-table",
      },
      {
        label: "4) Hazards",
        link: "/risk-hazard-table",
      },
      {
        label: "5) Risks",
        link: "/risk-assessment-table",
      },
      {
        label: "Control Measures",
        link: "/control-measure-table",
      },
      {
        label: "Scope Based Task Categories",
        link: "/job-task-category",
      },
    ],
  },
  {
    label: "Forms",
    icon: TableViewRounded,
    link: "/",
    childMenu: [
      {
        label: "Forms",
        link: "/form-table",
      },
      {
        label: "Allocation",
        link: "/form-allocation-table",
      },
      {
        label: "Policies & Procedures",
        link: "/template-table",
      },
      {
        label: "Checklists",
        link: "/checklists-overview",
      },
      {
        label: "Induction",
        link: "/induction-table",
      },
      {
        label: "Toolbox Talk",
        link: "/toolbox-talk-pages-table",
      },
      {
        label: "PTO",
        link: "/pto-topic-table",
      },
    ],
  },
  {
    label: "Emergency Contacts",
    icon: EmergencyRecordingIcon,
    link: "/emergency-contact",
    policy: 'emergency-contact'
  },
  {
    label: "Legislation",
    icon: InfoRounded,
    link: "/legislation",
  },
  {
    label: "Government Authorities",
    icon: FoundationRounded,
    link: "/department-of-labour",
  },
  {
    label: "Billing",
    icon: Paid,
    link: "/billing-view",
  },
  {
    label: "Communication",
    icon: Mail,
    link: "/communication-view",
  },
];
